// extracted by mini-css-extract-plugin
module.exports = {"ContainerView":"Notes_ContainerView__3YM70","NoComments":"Notes_NoComments__2uZat","containerNotes":"Notes_containerNotes__3KFHw"};